export function getImage (src) {
  return {
    url: src
  }
}
